/**
 * PathNav Style Schema
 * Defines node and connection styling options
 */

export const defaultNodeStyle = {
  shape: 'rounded',
  backgroundColor: '#ffffff',
  textColor: '#1f2937',
  borderColor: '#6366f1',
  borderWidth: 2,
  borderStyle: 'solid',
  shadow: {
    enabled: true,
    color: 'rgba(0,0,0,0.15)',
    blur: 8,
    offsetX: 2,
    offsetY: 2
  },
  padding: 16,
  fontSize: 14,
  fontWeight: 'normal',
  minWidth: 150,
  minHeight: 60
};

export const defaultConnectionStyle = {
  type: 'curved',
  color: '#9ca3af',
  width: 2,
  style: 'solid',
  arrowhead: true
};

export const stylePresets = {
  professional: {
    node: {
      ...defaultNodeStyle,
      shape: 'rectangle',
      backgroundColor: '#f8fafc',
      borderColor: '#334155',
      shadow: { enabled: true, color: 'rgba(0,0,0,0.1)', blur: 4, offsetX: 1, offsetY: 1 }
    },
    connection: { ...defaultConnectionStyle, type: 'straight', color: '#64748b' }
  },
  playful: {
    node: {
      ...defaultNodeStyle,
      shape: 'rounded',
      backgroundColor: '#fef3c7',
      borderColor: '#f59e0b',
      borderWidth: 3,
      shadow: { enabled: true, color: 'rgba(245,158,11,0.3)', blur: 12, offsetX: 3, offsetY: 3 }
    },
    connection: { ...defaultConnectionStyle, type: 'curved', color: '#f59e0b', width: 3 }
  },
  minimalist: {
    node: {
      ...defaultNodeStyle,
      shape: 'rectangle',
      backgroundColor: '#ffffff',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      shadow: { enabled: false }
    },
    connection: { ...defaultConnectionStyle, type: 'straight', color: '#d1d5db', width: 1, arrowhead: false }
  }
};
